import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ScrollToTop from '../components/scroll-to-top';
import About from '../pages/about';
import Blog from '../pages/blog';
import BlogDetails from '../pages/blog-details';
import Cart from '../pages/cart';
import Checkout from '../pages/checkout';
import Contact from '../pages/contact';
import Course from '../pages/course';
import CourseDetails from '../pages/curso-detalhes';
import CourseList from '../pages/course-list';
import CourseSidebar from '../pages/course-sidebar';
import DynamicBlogDetails from '../pages/d-blog-details';
import DynamicCourseDetails from '../pages/d-course-details';
import DynamicModuloDetails from '../pages/d-modulo-details';
import DynamicAulaDetails from '../pages/d-aula-details';
import DynamicAulaAssistirDetails from '../pages/d-aula-assistir';
import DynamicMateriaDetails from '../pages/d-materia-details';
import DynamicEventDetails from '../pages/d-event-details';
import DynamicInstructorDetails from '../pages/d-instructor-details';
import ErrorPage from '../pages/error-page';
import EventDetails from '../pages/event-details';
import Home from '../pages/home';
import HomeTwo from '../pages/home-2';
import HomeThree from '../pages/home-3';
import Instructor from '../pages/instructor';
import InstructorDetails from '../pages/instructor-details';
import SignIn from '../pages/sign-in';
import SignUp from '../pages/sign-up';
import Logout from '../pages/logout';
import MeuPerfil from '../pages/meu-perfil';
import EsqueciASenha from '../pages/esqueci-a-senha';
import MeusPagamentos from '../pages/meus-pagamentos';
import MinhasRedacoes from '../pages/minhas-redacoes';
import AssistirMaisTarde from '../pages/assistir-mais-tarde';
import MeusCursos from '../pages/meus-cursos';
import Wishlist from '../pages/wishlist';
import AssinarAgora from '../pages/assinar-agora';
import PagamentoFinalizado from '../pages/pagamento-finalizado';

const AppNavigation = () => {
  return (
    <>
      <Router>
        <ScrollToTop/>
        <Routes>
          <Route exact path="/" element={<Home />}></Route>
          {/* <Route path="/home-two" element={<HomeTwo />}></Route>
          <Route path="/home-three" element={<HomeThree />}></Route> */}
          <Route path="/cursos" element={<Course />}></Route>
          <Route path="/course-list" element={<CourseList />}></Route>
          <Route path="/course-sidebar" element={<CourseSidebar />}></Route>
          <Route path="/course-details" element={<CourseDetails />}></Route>
          <Route path="/curso-detalhes/:id" element={<DynamicCourseDetails />}></Route>
          <Route path="/curso/:id" element={<DynamicCourseDetails />}></Route>
          <Route path="/curso/:id/modulos" element={<DynamicModuloDetails />}></Route>
          <Route path="/modulo/aula/:id" element={<DynamicAulaDetails />}></Route>
          <Route path="/modulo/:idModulo/aula/assistir/:idAula" element={<DynamicAulaAssistirDetails />}></Route>
          <Route path="/materia/:id" element={<DynamicMateriaDetails />}></Route>
          {/* <Route path="/blog" element={<Blog />}></Route>
          <Route path="/blog-details" element={<BlogDetails />}></Route>
          <Route path="/blog-details/:id" element={<DynamicBlogDetails />}></Route> */}
          <Route path="/sobre" element={<About />}></Route>
          {/* <Route path="/instructor" element={<Instructor />}></Route>
          <Route path="/instructor-details" element={<InstructorDetails />}></Route>
          <Route path="/instructor-details/:id" element={<DynamicInstructorDetails />}></Route> */}
          <Route path="/event-details" element={<EventDetails />}></Route>
          <Route path="/event-details/:id" element={<DynamicEventDetails />}></Route>
          {/* <Route path="/cart" element={<Cart />}></Route>
          <Route path="/wishlist" element={<Wishlist />}></Route> */}
          <Route path="/checkout" element={<Checkout />}></Route>
          <Route path="/entrar" element={<SignIn />}></Route>
          <Route path="/inscrever-se" element={<SignUp />}></Route>
          <Route path="/logout" element={<Logout />}></Route>
          <Route path="/meu-perfil" element={<MeuPerfil />}></Route>
          <Route path="/esqueci-a-senha" element={<EsqueciASenha />}></Route>
          <Route path="/meus-pagamentos" element={<MeusPagamentos />}></Route>
          <Route path="/minhas-redacoes" element={<MinhasRedacoes />}></Route>
          <Route path="/assistir-mais-tarde" element={<AssistirMaisTarde />}></Route>
          <Route path="/meus-cursos" element={<MeusCursos />}></Route>
          <Route path="/contact" element={<Contact/>}></Route>
          <Route path="/assinar-agora/:cdPlano" element={<AssinarAgora />}></Route>
          <Route path="/pagamento-finalizado" element={<PagamentoFinalizado />}></Route>
          <Route path="/error" element={<ErrorPage />}></Route>
          <Route path="*" element={<ErrorPage />}></Route>
        </Routes>
      </Router>
    </>
  );
};

export default AppNavigation;